<template>
  <b-row>
    <b-col v-if="!tableDetail">
      <b-card no-body>
        <div slot="header">
          <div v-html="caption" class="float-left"></div>
          <div class="float-right">
            <b-button
              size="sm"
              v-if="uploadByExcell"
              v-on:click.prevent="addFormExcell($event.target)"
              variant="stack-overflow"
              class="mr-1 btn-brand"
            >
              <i class="fa fa-upload"></i>
              <span>{{ addExcellButton }}</span>
            </b-button>

            <b-button
              size="sm"
              v-if="generateAutoSpkb && !busyx"
              v-on:click.prevent="generateSPKB($event.target)"
              variant="stack-overflow"
              class="mr-1 btn-brand"
            >
              <i class="fa fa-gear"></i>
              <span>Generate SPKB</span>
            </b-button>

            <b-button
              size="sm"
              v-if="showAddButton"
              v-on:click.prevent="addForm($event.target)"
              variant="stack-overflow"
              class="mr-1 btn-brand float-right"
            >
              <i class="fa fa-plus"></i>
              <span>{{ addButton }}</span>
            </b-button>
          </div>
        </div>

        <b-card-body>
          <b-row>
            <b-col lg="12" v-if="!loading">
              <b-form id="filterForm">
                <b-row>
                  <b-col sm="3">
                    <b-form-group label-for="" label="Searching">
                      <b-form-input
                        v-model="filter.search"
                        placeholder="Searching"
                        debounce="500"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                 
                  <b-col sm="3" v-if="searchByDeliveryDate">
                    <b-form-group label-for="date" label="Tanggal Pengiriman">
                      <v-date-picker
                        mode="range"
                        id="date"
                        :input-props="{
                          class: 'form-control',
                          placeholder: 'Tanggal Pengiriman',
                          required: '',
                          readonly: '',
                        }"
                        v-model="filter.date"
                      ></v-date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" v-if="searchByNooDate">
                    <b-form-group label-for="date" label="Tanggal Input">
                      <v-date-picker
                        mode="range"
                        id="date"
                        :input-props="{
                          class: 'form-control',
                          placeholder: 'Tanggal Input',
                          required: '',
                          readonly: '',
                        }"
                        v-model="filter.date"
                      ></v-date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" v-if="searchByLeadDate">
                    <b-form-group label-for="date" label="Tanggal Input">
                      <v-date-picker
                        mode="range"
                        id="date"
                        :input-props="{
                          class: 'form-control',
                          placeholder: 'Tanggal Input',
                          required: '',
                          readonly: '',
                        }"
                        v-model="filter.date"
                      ></v-date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" v-if="searchBySurveyDate">
                    <b-form-group label-for="date" label="Tanggal Survey">
                      <v-date-picker
                        mode="range"
                        id="date"
                        :input-props="{
                          class: 'form-control',
                          placeholder: 'Tanggal Survey',
                          required: '',
                          readonly: '',
                        }"
                        v-model="filter.date"
                      ></v-date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" v-if="searchByTransactionDate">
                    <b-form-group label-for="date" label="Tanggal Transaksi">
                      <v-date-picker
                        mode="range"
                        id="date"
                        :input-props="{
                          class: 'form-control',
                          placeholder: 'Tanggal Transaksi',
                          required: '',
                          readonly: '',
                        }"
                        v-model="filter.date"
                      ></v-date-picker>
                    </b-form-group>
                  </b-col>
                   <b-col sm="3" v-if="searchByBank">
                    <b-form-group label-for="bank" label="Bank">
                      <model-select
                        id="bank"
                        :options="listBank"
                        v-model="filter.bank"
                        placeholder="Konsumen"
                      ></model-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" v-if="searchByStatusUnposted">
                    <b-form-group label-for="status_unposted" label="Status">
                      <model-select
                        id="status_unposted"
                        :options="listStatusUnposted"
                        v-model="filter.unposted"
                        placeholder="Status"
                      ></model-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3" v-if="searchByCustomer">
                    <b-form-group label-for="customer" label="Konsumen">
                      <model-select
                        id="customer"
                        :options="listCustomer"
                        v-model="filter.customer"
                        placeholder="Konsumen"
                      ></model-select>
                    </b-form-group>
                  </b-col>
                   <b-col sm="3" v-if="searchByCustomerGroup">
                      <b-form-group label-for="customer-group" label="Grup Outlet">
                        <model-select
                          id="customer_group"
                          :options="listCustomerGroup"
                          v-model="filter.customer_group"
                          placeholder="Konsumen"
                        ></model-select>
                      </b-form-group>
                    </b-col>
                </b-row>
                <b-row></b-row>
              </b-form>
            </b-col>
            <b-col lg="12">
              <div>
                <b-table
                  ref="myTable"
                  :filter="filter"
                  :busy="busyx"
                  :dark="dark"
                  :hover="hover"
                  :striped="striped"
                  :bordered="bordered"
                  :small="small"
                  :fixed="fixed"
                  :items="tableData"
                  :fields="captions"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :show-empty="true"
                  :redirect-detail="redirectDetail"
                  responsive="sm"
                  head-variant="light"
                  @filtered="onFiltered"
                >
                  <template #table-busy>
                    <loading></loading>
                  </template>

                   <template v-slot:cell(leads_info)="data">
                      <template v-if="data.item.lead_code === null"> - </template>
                      <template v-else>
                          <div>{{data.item.lead_code}}</div>
                          <div>{{data.item.lead_by_name}}</div>
                          <div>{{dateTimeFormat(data.item.date_inserted)}}</div>
                      </template>
                    </template>

                  <template v-slot:cell(date)="data">
                    <div
                      v-if="data.item.date"
                      v-html="dateFormat(data.item.date)"
                    ></div>
                  </template>

                  <template v-slot:cell(date_inserted)="data">
                    <div
                      v-if="data.item.date_inserted"
                      v-html="dateFormat(data.item.date_inserted)"
                    ></div>
                  </template>

                  <template v-slot:cell(transaction_date)="data">
                    <div
                      v-if="data.item.transaction_date"
                      v-html="dateFormat(data.item.transaction_date)"
                    ></div>
                  </template>

                  <template v-slot:cell(mutation)="data">
                    <div
                      v-html="'Rp. ' + formatPrice2(data.item.mutation)"
                    ></div>
                  </template>

                  <template v-slot:cell(total_mutation)="data">
                    <div
                      v-html="'Rp. ' + formatPrice2(data.item.total_mutation)"
                    ></div>
                  </template>

                  <template v-slot:cell(description_transaction)="data">
                    <div>{{data.item.description}}</div>
                    <template v-if="data.item.status = '2'">
                      <b-badge :variant="'info'">{{ data.item.category_name }}</b-badge>&nbsp;
                      <b-badge :variant="'info'">{{ data.item.transaction_type }}</b-badge><br/>
                      <b-badge :variant="'warning'">{{ data.item.detail_description }}</b-badge>

                    </template>
                  </template>

                  <template v-slot:cell(customer_name_history_asset)="data">
                    <div v-if="data.item.customer_name_history_asset">{{data.item.customer_name}}<br><small>{{data.item.contract_number}}</small></div>
                  </template>

                  <template v-slot:cell(process_time)="data">
                    <div
                      v-if="data.item.process_time"
                      v-html="dateFormat(data.item.process_time)"
                    ></div>
                  </template>

                  <template v-slot:cell(attendance_history_date)="data">
                    <div
                      v-html="dateTimeFormat(data.item.attendance_history_date)"
                    ></div>
                  </template>

                  <template v-slot:cell(plan_delivery_order)="data">
                    <div
                      v-html="dateFormat(data.item.plan_delivery_order)"
                    ></div>
                  </template>

                  <template v-slot:cell(date_order)="data">
                    <div v-html="dateTimeFormat(data.item.date_order)"></div>
                  </template>

                  <template v-slot:cell(delivery_date)="data">
                    <div v-html="dateFormat(data.item.delivery_date)"></div>
                  </template>

                  <template v-slot:cell(date_inserted_cvo_visit)="data">
                    <div v-html="dateTimeFormat(data.item.date_inserted)"></div>
                  </template>

                  <template v-slot:cell(attendance_date)="data">
                    <div v-html="dateFormat(data.item.attendance_date)"></div>
                  </template>

                  <template v-slot:cell(total_price_plan)="data">
                    <div
                      v-html="'Rp. ' + formatPrice(data.item.total_price_plan)"
                    ></div>
                  </template>

                  <template v-slot:cell(total_price_actual)="data">
                    <div
                      v-html="
                        'Rp. ' + formatPrice(data.item.total_price_actual)
                      "
                    ></div>
                  </template>

                  <template v-slot:cell(total_price_retur)="data">
                    <div
                      v-html="'Rp. ' + formatPrice(data.item.total_price_retur)"
                    ></div>
                  </template>

                  <template v-slot:cell(price)="data">
                    <div v-html="'Rp. ' + formatPrice(data.item.price)"></div>
                  </template>

                  <template v-slot:cell(fee)="data">
                    <div v-html="'Rp. ' + formatPrice(data.item.fee)"></div>
                  </template>

                  <template v-slot:cell(status)="data">
                    <b-badge :variant="getBadge(data.item.status)">{{
                      data.item.status
                    }}</b-badge>
                  </template>

                  <template v-slot:cell(level_access)="data">
                    <div v-if="data.item.level === '1'">
                      Level Akses Manager
                    </div>
                    <div v-if="data.item.level === '2'">Level Akses SPV</div>
                    <div v-if="data.item.level === '3'">Level Akses Staff</div>
                  </template>

                  <template v-slot:cell(employee_profile)="data">
                    <div>
                      <div>
                        {{ data.item.nik + " - " + data.item.name }}
                        <small v-if="data.item.surename !== null"
                          >({{ data.item.surename }})</small
                        >
                        <label
                          v-if="data.item.status === '6'"
                          class="badge badge-danger"
                          >{{ data.item.status_employee }}</label
                        >
                        <label
                          v-else-if="data.item.status === '1'"
                          class="badge badge-primary"
                          >{{ data.item.status_employee }}</label
                        >
                        <label v-else class="badge badge-warning">{{
                          data.item.status_employee
                        }}</label>
                      </div>
                      <span>
                        <small>
                          <i class="fa fa-calendar" /> :
                          <span
                            v-html="dateFormat(data.item.start_join)"
                          ></span>
                          <span v-if="data.item.end_date !== null">
                            &nbsp;-
                            <span
                              v-html="dateFormat(data.item.end_date)"
                            ></span>
                          </span>
                        </small>
                      </span>
                      <div>
                        <small>
                          <i class="fa fa-mobile" style="margin: 0 6px 0 0" /> :
                          <span v-html="data.item.mobile_phone"></span>
                        </small>
                      </div>
                    </div>
                  </template>

                  <template v-slot:cell(employee_bank_profile)="data">
                    <div>
                      <div>{{ data.item.name }}</div>
                      <small>
                        <div>
                          <i class="fa fa-bank" /> :
                          <span
                            >{{ data.item.bank_account_number }} -
                            {{ data.item.bank_name }}</span
                          >
                        </div>
                      </small>
                    </div>
                  </template>

                  <template v-slot:cell(customer_detail)="data">
                    <div>
                      <div>{{ data.item.name }}</div>
                      <div>
                        <i class="fa fa-group" />
                        : {{ data.item.customer_group_name }} /
                        <label
                          v-if="
                            data.item.lng !== null && data.item.lat !== null
                          "
                        >
                          <a :href="'https://www.google.com/maps?q='+data.item.lat+','+data.item.lng" variant="ghost-primary">
                            <i class="fa fa-globe" />
                          </a>
                        </label>
                        <small
                          v-if="data.item.lng == null || data.item.lat === null"
                          >(Lokasi belum ada)</small
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:cell(lead_date_inserted)="data">
                    <div v-html="dateTimeFormat(data.item.lead_date_inserted)"></div>
                  </template>

                  <template v-slot:cell(leads_detail)="data">
                    <div>
                      <div>{{ data.item.name }}</div>
                      <div>
                        <small>
                          <span class="badge bg-primary">{{ data.item.province_name }}</span>&nbsp;<span class="badge bg-primary">{{ data.item.regencies_name }}</span><br/>
                          <span class="badge bg-primary">{{ data.item.district_name }}</span>&nbsp;<span class="badge bg-primary">{{ data.item.villages_name }}</span>
                        </small>
                      </div>
                      <div>
                        <small>
                          <i class="fa fa-group" />
                          : {{ data.item.owner_name }} /
                          <label
                            v-if="
                              data.item.lng !== null && data.item.lat !== null
                            "
                          >
                            <a :href="'https://www.google.com/maps?q='+data.item.lat+','+data.item.lng" variant="ghost-primary">
                              <i class="fa fa-globe" />
                            </a>
                          </label>
                          <small
                            v-if="data.item.lng == null || data.item.lat === null"
                            >(Lokasi belum ada)</small
                          >
                        </small>
                    </div>
                    <div>
                      <small>
                        <i class="fa fa-mobile" />
                        : {{ (data.item.handphone != null) ? data.item.handphone: "-" }} / {{ (data.item.handphone2 != null) ? data.item.handphone2: "-" }} / {{ (data.item.handphone3 != null) ? data.item.handphone3: "-" }}
                      </small>
                    </div>
                    
                    </div>
                  </template>

                  <template v-slot:cell(show_detail)="data">
                    <b-button
                      type="button"
                      @click="showDetail($event, data)"
                      size="sm"
                      variant="primary"
                      title="Show this data"
                    >
                      <i class="cui-note icons"></i>
                    </b-button>
                  </template>

                  <template v-slot:cell(action)="data">
                    <b-button
                      v-if="redirectDetail && editButton"
                      type="button"
                      @click="goToDetail(data.item)"
                      size="sm"
                      variant="primary"
                      title="Go To detail"
                    >
                      <i class="cui-note icons"></i>
                    </b-button>
                    <b-button
                      v-else-if="!redirectDetail && editButton"
                      type="button"
                      @click="editForm(data.item)"
                      size="sm"
                      variant="primary"
                      title="Edit this data"
                    >
                      <i class="cui-note icons"></i> </b-button
                    >&nbsp;
                    <b-button
                      v-if="removeButton"
                      type="button"
                      size="sm"
                      variant="danger"
                      title="Remove this data"
                      @click="removeForm(data.item)"
                    >
                      <i class="cui-circle-x icons"></i> </b-button
                    >
                    <b-button
                      v-if="removeButtonBankBook && data.item.stat_transaction === '2'"
                      type="button"
                      size="sm"
                      variant="danger"
                      title="Remove this data"
                      @click="removeForm(data.item)"
                    >
                      <i class="cui-circle-x icons"></i> </b-button
                    >
                    &nbsp;
                    <b-button
                      v-if="customButtonDetail"
                      type="button"
                      @click="goToDetail(data.item)"
                      size="sm"
                      variant="primary"
                      title="Go To detail"
                    >
                      <i class="cui-layers icons"></i>
                    </b-button>
                  </template>

                  <template v-slot:cell(action_spkb)="data">
                    <template v-if="editButton">
                      <b-button
                        type="button"
                        @click="goToDetail(data.item)"
                        size="sm"
                        variant="primary"
                        title="Go To detail"
                      >
                        <i class="cui-note icons"></i> </b-button
                      >&nbsp;
                      <b-button
                        v-if="
                          data.item.driver !== null &&
                          (data.item.invoice_pic_employee !== null ||
                            data.item.invoice_pic_dc !== null)
                        "
                        type="button"
                        @click="print_surat_jalan(data)"
                        size="sm"
                        variant="info"
                        title="Print Surat Jalan"
                      >
                        <i class="fa fa-print"></i>
                      </b-button>
                    </template>

                    <template v-if="!editButton">
                      <b-button
                        v-if="
                          data.item.driver === null &&
                          (data.item.invoice_pic_employee === null ||
                            data.item.invoice_pic_dc === null)
                        "
                        type="button"
                        @click="goToDetail(data.item)"
                        size="sm"
                        variant="primary"
                        title="Go To detail"
                      >
                        <i class="cui-note icons"></i>
                      </b-button>
                      <b-button
                        v-if="
                          data.item.driver !== null &&
                          (data.item.invoice_pic_employee !== null ||
                            data.item.invoice_pic_dc !== null)
                        "
                        type="button"
                        @click="print_surat_jalan(data)"
                        size="sm"
                        variant="info"
                        title="Print Surat Jalan"
                      >
                        <i class="fa fa-print"></i>
                      </b-button>
                    </template>
                  </template>

                  <template v-slot:cell(action_retur)="data">
                    <b-button
                      v-if="redirectDetail && editButton"
                      type="button"
                      @click="goToDetail(data.item)"
                      size="sm"
                      variant="primary"
                      title="Go To detail"
                    >
                      <i class="cui-note icons"></i>
                    </b-button>
                    <b-button
                      v-else-if="!redirectDetail && editButton"
                      type="button"
                      @click="editForm(data.item)"
                      size="sm"
                      variant="primary"
                      title="Edit this data"
                    >
                      <i class="cui-note icons"></i> </b-button
                    >&nbsp;
                    <b-button
                      type="button"
                      size="sm"
                      variant="info"
                      title="Bypass"
                      @click="byPass(data.item)"
                    >
                      <i class="cui-circle-x icons"></i> </b-button
                    >&nbsp;
                  </template>

                   <template v-slot:cell(action_piutang)="data">
                    <b-button
                      v-if="redirectDetail && editButton"
                      type="button"
                      @click="goToDetail(data.item)"
                      size="sm"
                      variant="primary"
                      title="Go To detail"
                    >
                      <i class="cui-note icons"></i>
                    </b-button>
                    &nbsp;
                    <b-button
                      type="button"
                      size="sm"
                      variant="warning"
                      title="Penyesuaian Aktual"
                      @click="adjustmentActualSpkb(data.item)"
                    >
                      <i class="fa fa-sliders"></i> </b-button
                    >&nbsp;
                    <b-button
                      type="button"
                      size="sm"
                      variant="info"
                      title="Penyesuaian Retur"
                      @click="adjustmentReturSpkb(data.item)"
                    >
                      <i class="fa fa-repeat"></i> </b-button
                    >
                  </template>
                  
                </b-table>
                <!-- <nav v-if="!loading"> -->
                <b-pagination
                  v-if="pagination && !loading"
                  align="right"
                  size="sm"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  prev-text="Prev"
                  next-text="Next"
                  first-text="First"
                  last-text="Last"
                />
                <!-- </nav> -->
              </div>

              <!-- <div v-else>
                <loading></loading>
              </div> -->
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col v-else-if="tableDetail">
      <b-row>
        <b-col lg="12">
          <div v-if="!loading">
            <b-row>
              <b-col v-if="showAddButton">
                <b-button
                  size="sm"
                  v-on:click.prevent="addForm($event.target)"
                  variant="stack-overflow"
                  style="margin-bottom: 10px"
                  class="mr-1 btn-brand float-right"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ addButton }}</span>
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="filterTableOnly">
                <b-form id="filterForm">
                  <b-row>
                    <b-col sm="3">
                      <b-form-group label-for="" label="&nbsp;">
                        <b-form-input
                          v-model="filter.search"
                          placeholder="Searching"
                          debounce="500"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    
                    <b-col sm="3" v-if="searchByDeliveryDate">
                      <b-form-group label-for="date" label="Tanggal Pengiriman">
                        <v-date-picker
                          mode="range"
                          id="date"
                          :input-props="{
                            class: 'form-control',
                            placeholder: 'Tanggal Pengiriman',
                            required: '',
                            readonly: '',
                          }"
                          v-model="filter.date"
                        ></v-date-picker>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3" v-if="searchByNooDate">
                      <b-form-group label-for="date" label="Tanggal Input">
                        <v-date-picker
                          mode="range"
                          id="date"
                          :input-props="{
                            class: 'form-control',
                            placeholder: 'Tanggal Input',
                            required: '',
                            readonly: '',
                          }"
                          v-model="filter.date"
                        ></v-date-picker>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3" v-if="searchByLeadDate">
                      <b-form-group label-for="date" label="Tanggal Input">
                        <v-date-picker
                          mode="range"
                          id="date"
                          :input-props="{
                            class: 'form-control',
                            placeholder: 'Tanggal Input',
                            required: '',
                            readonly: '',
                          }"
                          v-model="filter.date"
                        ></v-date-picker>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3" v-if="searchBySurveyDate">
                      <b-form-group label-for="date" label="Tanggal Survey">
                        <v-date-picker
                          mode="range"
                          id="date"
                          :input-props="{
                            class: 'form-control',
                            placeholder: 'Tanggal Survey',
                            required: '',
                            readonly: '',
                          }"
                          v-model="filter.date"
                        ></v-date-picker>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3" v-if="searchByTransactionDate">
                      <b-form-group label-for="date" label="Tanggal Transaksi">
                        <v-date-picker
                          mode="range"
                          id="date"
                          :input-props="{
                            class: 'form-control',
                            placeholder: 'Tanggal Transaksi',
                            required: '',
                            readonly: '',
                          }"
                          v-model="filter.date"
                        ></v-date-picker>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3" v-if="searchByBank">
                      <b-form-group label-for="bank" label="Bank">
                        <model-select
                          id="bank"
                          :options="listBank"
                          v-model="filter.bank"
                          placeholder="Konsumen"
                        ></model-select>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3" v-if="searchByStatusUnposted">
                      <b-form-group label-for="status_unposted" label="Status">
                        <model-select
                          id="status_unposted"
                          :options="listStatusUnposted"
                          v-model="filter.unposted"
                          placeholder="Status"
                        ></model-select>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3" v-if="searchByCustomer">
                      <b-form-group label-for="customer" label="Konsumen">
                        <model-select
                          id="customer"
                          :options="listCustomer"
                          v-model="filter.customer"
                          placeholder="Konsumen"
                        ></model-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="3" v-if="searchByCustomerGroup">
                      <b-form-group label-for="customer-group" label="Grup Outlet">
                        <model-select
                          id="customer_group"
                          :options="listCustomerGroup"
                          v-model="filter.customer_group"
                          placeholder="Konsumen"
                        ></model-select>
                      </b-form-group>
                    </b-col>
                    <!-- <b-col sm="3">
                      <b-form-group>
                        <b-form-input v-model="filter.search" placeholder=" Searching"></b-form-input>
                      </b-form-group>
                    </b-col> -->
                  </b-row>
                </b-form>
              </b-col>
            </b-row>

            <b-table
              ref="myTable"
              :filter="filter"
              :dark="dark"
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :busy="busyx"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="items"
              :fields="captions"
              head-variant="light"
              :current-page="currentPage"
              :per-page="perPage"
              :show-empty="true"
              :redirect-detail="redirectDetail"
            >

          <template v-slot:cell(leads_info)="data">
                <template v-if="data.item.lead_code === null"> - </template>
                <template v-else>
                    <div>{{data.item.lead_code}}</div>
                    <div>{{data.item.lead_by_name}}</div>
                    <div>{{dateTimeFormat(data.item.date_inserted)}}</div>
                </template>
              </template>


              <template v-slot:cell(customer_name_history_asset)="data">
                <div>{{data.item.customer_name}}<br><small>{{data.item.contract_number}}</small></div>
              </template>

              <template v-slot:cell(periode_placement_date)="data">
                <div>
                  {{dateFormat(data.item.placement_date)}}
                  <template v-if="data.item.return_date === null"> - Now</template>
                  <template v-else> - {{dateFormat(data.item.return_date)}}</template>
                </div>
              </template>

              <template v-slot:cell(price_plan)="data">
                <div v-html="formatPrice(data.item.price_plan)"></div>
              </template>

              <template v-slot:cell(attendance_history_date)="data">
                <div
                  v-html="dateTimeFormat(data.item.attendance_history_date)"
                ></div>
              </template>

              <template v-slot:cell(plan_delivery_order)="data">
                <div v-html="dateFormat(data.item.plan_delivery_order)"></div>
              </template>

              <template v-slot:cell(date_order)="data">
                <div v-html="dateTimeFormat(data.item.date_order)"></div>
              </template>

              <template v-slot:cell(date_inserted)="data">
                <div v-html="dateTimeFormat(data.item.date_inserted)"></div>
              </template>

              <template v-slot:cell(date_inserted_cvo_visit)="data">
                <div v-html="dateTimeFormat(data.item.date_inserted)"></div>
              </template>

              <template v-slot:cell(total_price_plan)="data">
                <div v-html="formatPrice(data.item.total_price_plan)"></div>
              </template>

              <template v-slot:cell(price)="data">
                <div v-html="'Rp. ' + formatPrice(data.item.price)"></div>
              </template>

              <template v-slot:cell(fee)="data">
                <div v-html="'Rp. ' + formatPrice(data.item.fee)"></div>
              </template>

              <template v-slot:cell(placement_date)="data">
                <div v-html="dateFormat(data.item.placement_date)"></div>
              </template>

               <template v-slot:cell(placement_date_alias)="data">
                <div v-html="dateFormat(data.item.placement_date_alias)"></div>
              </template>

              <template v-slot:cell(expired_date)="data">
                <div v-html="dateFormat(data.item.expired_date)"></div>
              </template>

              <template v-slot:cell(attendance_date)="data">
                <div v-html="dateFormat(data.item.attendance_date)"></div>
              </template>

              <template v-slot:cell(return_date)="data">
                <div v-html="dateFormat(data.item.return_date)"></div>
              </template>

              <template v-slot:cell(last_order_date)="data">
                <div v-html="dateFormat(data.item.last_order_date)"></div>
              </template>

              <template v-slot:cell(contract_number_download)="data">
                <div>
                  <a style="cursor: pointer" @click="download_file(data)">
                    <i class="fa fa-cloud-download"></i>
                    {{ data.item.contract_number }}
                  </a>
                </div>
              </template>

               <template v-slot:cell(contract_number_download_alter)="data">
                <div>
                  <a style="cursor: pointer" @click="download_file_alter(data)">
                    <i class="fa fa-cloud-download"></i>
                    {{ data.item.contract_number }}
                  </a>
                </div>
              </template>

              <template v-slot:cell(contract_number_return_download)="data">
                <div>
                  <a
                    style="cursor: pointer"
                    target="_blank"
                    :href="
                      axios.defaults.baseURL +
                      'web/export_pdf/assets/generate_return_asset/' +
                      data.item.customer_id +
                      '/' +
                      data.item.id +
                      '/'
                    "
                  >
                    <i class="fa fa-cloud-download"></i>
                    {{ data.item.contract_number }}
                  </a>
                </div>
              </template>

              <template v-slot:cell(document_name_preview)="data">
                <div>
                  <a
                    style="cursor: pointer"
                    :href="
                      download_document('customer/document/', data.item.file)
                    "
                    target="_blank"
                  >
                    <i class="fa fa-cloud-download"></i>
                    {{ data.item.name }}
                  </a>
                </div>
              </template>

              <template v-slot:cell(action)="data">
                <b-button
                  v-if="redirectDetail && editButton"
                  type="button"
                  @click="goToDetail(data.item)"
                  size="sm"
                  variant="primary"
                  title="Go To detail"
                >
                  <i class="cui-note icons"></i>
                </b-button>
                <b-button
                  v-else-if="!redirectDetail && editButton"
                  type="button"
                  @click="editForm(data.item)"
                  size="sm"
                  variant="primary"
                  title="Edit this data"
                >
                  <i class="cui-note icons"></i> </b-button
                >&nbsp;
                <b-button
                  v-if="removeButton"
                  type="button"
                  size="sm"
                  variant="danger"
                  title="Remove this data"
                  @click="removeForm(data.item)"
                >
                  <i class="cui-circle-x icons"></i> </b-button
                >
                <b-button
                  v-if="removeButtonBankBook && data.item.stat_transaction === '2'"
                  type="button"
                  size="sm"
                  variant="danger"
                  title="Remove this data"
                  @click="removeForm(data.item)"
                >
                  <i class="cui-circle-x icons"></i> </b-button
                >&nbsp;
                <b-button
                  v-if="customButtonDetail"
                  type="button"
                  @click="goToDetail(data.item)"
                  size="sm"
                  variant="primary"
                  title="Go To detail"
                >
                  <i class="cui-layers icons"></i>
                </b-button>
              </template>
            </b-table>
            <nav v-if="!loading">
              <b-pagination
                v-if="pagination"
                align="right"
                size="sm"
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                prev-text="Prev"
                next-text="Next"
                first-text="First"
                last-text="Last"
              />
            </nav>
          </div>

          <div v-else>
            <loading></loading>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import * as moment from "moment";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";

export default {
  name: "global-table",
  inheritAttrs: false,
  components: { loading, ModelSelect },
  props: {
    caption: {
      type: String,
      default: "Table",
    },
    addButton: {
      type: String,
      default: "",
    },
    addExcellButton: {
      type: String,
      default: "",
    },
    hover: {
      type: Boolean,
      default: false,
    },
    striped: {
      type: Boolean,
      default: false,
    },
    busyx: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    redirectDetail: {
      type: Boolean,
      default: true,
    },
    showAddButton: {
      type: Boolean,
      default: true,
    },
    uploadByExcell: {
      type: Boolean,
      default: false,
    },
    generateAutoSpkb: {
      type: Boolean,
      default: false,
    },
    removeButton: {
      type: Boolean,
      default: false,
    },
    removeButtonBankBook: {
      type: Boolean,
      default: false,
    },
    editButton: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: [Array, Object, Function],
      default: () => [],
    },
    // filter: {
    //   type: String,
    //   default: ""
    // },
    fields: {
      type: [Array, Object],
      default: () => [],
    },
    perPage: {
      type: Number,
      default: 5,
    },
    totalData: {
      type: String,
      default: "0",
    },
    dark: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tableDetail: {
      type: Boolean,
      default: false,
    },
    filterTableOnly: {
      type: Boolean,
      default: false,
    },
    idModals: {
      type: String,
      default: "addModals",
    },
    idModalsByExcell: {
      type: String,
      default: "addModalsByExcell",
    },
    customVariableId: {
      type: String,
      default: "id",
    },
    customButtonDetail: {
      type: Boolean,
      default: false,
    },
    filterOn: {
      type: [Array, Object],
      default: () => [],
    },
    searchByDeliveryDate: {
      type: Boolean,
      default: false,
    },
    searchByCustomer: {
      type: Boolean,
      default: false,
    },
    searchByCustomerGroup: {
      type: Boolean,
      default: false,
    },
    searchByBank: {
      type: Boolean,
      default: false,
    },
    searchByStatusUnposted: {
      type: Boolean,
      default: false,
    },
    searchByNooDate: {
      type: Boolean,
      default: false,
    },
    searchByLeadDate: {
      type: Boolean,
      default: false,
    },
    searchBySurveyDate: {
      type: Boolean,
      default: false,
    },
    searchByTransactionDate: {
      type: Boolean,
      default: false,
    },
    listBank: {
      type: [Array, Object],
      default: () => [],
    },
    listStatusUnposted: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data: () => {
    return {
      myData: [],
      currentPage: 1,
      filterTotalRows: 0,
      listCustomer: [],
      listCustomerGroup: [],
      filter: {
        search: null,
        customer_group: null,
        date: {
          end: new Date(),
          start: new Date(Date.now() - 86400000),
        },
        customer: null,
        bank: null,
        unposted: null
      },
    };
  },
  computed: {
    items: function () {
      const items = this.tableData;
      return items;
      //return Array.isArray(items) ? items : Object.values(items);
    },
    totalRows: function () {
      // if (this.filter !== null) {
      //   return this.filterTotalRows;
      // } else {
      return this.getRowCount();
      //}
    },
    captions: function () {
      return this.fields;
    },
  },
  watch: {
    $route(to, from) {
      //console.log(to)
      //console.log(from)
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init: function () {
      this.myData = this.items;
      if (this.searchByCustomer === true) {
        this.getDropdown();
      }
      if (this.searchByCustomerGroup === true) {
        this.getDropdownCustomerGroup();
      }
      //this.totalRows = this.getRowCount();
    },
    getBadge: function (status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    goToDetail: function (row) {
      let path = this.$route.path.split("/");
      //console.log(path)
      //
      /*
         this.$router.push({
          path: (path[1] === 'master') ? path[2]+'/detail/'+row.id : 'detail/'+row.id
        })
         */
      this.$router.push({
        path: path.hasOwnProperty("2")
          ? path[2] + "/detail/" + row[this.customVariableId]
          : "detail/" + row[this.customVariableId],
      });
    },
    editForm: function (row) {
      this.$emit("editForm", row);
      this.$emit("isEdit", true);
      this.$root.$emit("bv::show::modal", this.idModals);
    },
    addForm: function (button) {
      this.$emit("isEdit", false);
      this.$emit("resetForm");
      this.$root.$emit("bv::show::modal", this.idModals, button);
    },
    addFormExcell: function (button) {
      this.$emit("isEdit", false);
      this.$emit("resetFormUploadForm");
      this.$root.$emit("bv::show::modal", this.idModalsByExcell, button);
    },
    generateSPKB: function (button) {
      this.$emit("isEdit", false);
      this.$emit("generateAutoSPKB");
    },
    removeForm: function (row) {
      this.$emit("removeForm", row);
    },
    byPass: function (row) {
      this.$emit("byPass", row);
    },
    adjustmentActualSpkb: function (row) {
      this.$emit("adjustmentActualSpkb", row);
      let path = this.$route.path.split("/");
    
      this.$router.push({
        path: path.hasOwnProperty("2")
          ? path[2] + "/adjustment-actual/" + row[this.customVariableId]
          : "adjustment-actual/" + row[this.customVariableId],
      });
    },
    adjustmentReturSpkb: function (row) {
      this.$emit("adjustmentReturSpkb", row);
      let path = this.$route.path.split("/");
    
      this.$router.push({
        path: path.hasOwnProperty("2")
          ? path[2] + "/adjustment-retur/" + row[this.customVariableId]
          : "adjustment-retur/" + row[this.customVariableId],
      });
    },
    close: function () {
      //console.log("aaa");
    },
    getRowCount: function () {
      //return this.items.length;
      return this.totalData;
    },
    dateFormat: function (date) {
      return date === null ? "" : moment(date).format("DD MMM YYYY");
    },
    dateTimeFormat: function (date) {
      return moment(date).format("DD MMM YYYY HH:mm:ss");
    },
    showDetail: function (button, row) {
      this.$emit("showDetail", row);
      this.$root.$emit("bv::show::modal", "openDetail", button);
    },
    onFiltered(filteredItems) {
      //this.totalRows(filteredItems)
      this.filterTotalRows = filteredItems.length;
      //this.currentPage = 1; BECAUSE FILTERING BASED ON QUERY
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatPrice2(value) {
      let val = (value / 1).toFixed(2);//parseFloat(value);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    dateFormatRange: function (date) {
      let temp = "";
      if (date !== "") {
        for (var d in date) {
          temp +=
            temp === ""
              ? moment(date[d]).format("DD MMM YYYY")
              : ", " + moment(date[d]).format("DD MMM YYYY");
        }
        return temp;
      } else {
        return "";
      }
    },
    download_file: function (data, path = "generate_customer_asset") {
      if(['58','59'].includes(data.item.customer_group)) {
        path = 'generate_customer_asset_afull';
      } else if (['60'].includes(data.item.customer_group)) {
        path = 'generate_customer_asset_coko';
      }
      
      window.location.href =
        axios.defaults.baseURL +
        "web/export_pdf/assets/" +
        path +
        "/" +
        data.item.customer_id +
        "/" +
        data.item.id +
        "/";
    },
    download_file_alter: function (data, path = "generate_customer_asset") {
      window.location.href =
        axios.defaults.baseURL +
        "web/export_pdf/assets_alter/" +
        path +
        "/" +
        data.item.customer_id +
        "/" +
        data.item.id +
        "/";
    },
    download_document: function (path, file) {
      return axios.defaults.upload_path + path + file;
    },
    print_surat_jalan: function (data) {
      if (data.item.delivery_date !== null) {
        if(confirm("Apakah anda ingin meng-print surat jalan ini ?")) {
          this.axios({
            url:
              "web/export_pdf/surat_jalan/generate_surat_jalan/" +
              data.item.spkb_number +
              "/",
            method: "GET",
            responseType: "blob",
          }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", data.item.spkb_number + ".pdf");
              document.body.appendChild(link);
              link.click();
            })
            .catch((error) => {
              if (error.response.status === 401) {
                this.expired(error, "");
              }
            })
            .finally(() => {});
          }

        // window.open(
        //   axios.defaults.baseURL +
        //     "web/export_pdf/surat_jalan_new_format/generate_surat_jalan/" +
        //     data.item.spkb_number +
        //     "/"
        // );
      } else {
        // if(data.item.print === '1') {
        //   alert("SPKB ini sudah di print.");
        // } else {
          alert("Harap masukkan tanggal pengiriman");
        //}
      }
    },
    getDropdown: function () {
      this.loadingDropdown = true;
      this.axios
        .get("web/dropdown/dropdown-spkb/")
        .then((response) => {
          this.listCustomer = response.data.customer;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loadingDropdown = false;
        });
    },
    getDropdownCustomerGroup: function () {
      this.loadingDropdown = true;
      this.axios
        .get("web/dropdown/dropdown-customer-group/")
        .then((response) => {
          this.listCustomerGroup = response.data.customer_group;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loadingDropdown = false;
        });
    },
  },
};
</script>
